import Link from "next/link"
import { designTokens } from "@/lib/design-tokens"

interface BreadcrumbItem {
  href?: string
  label: string
  current?: boolean
}

interface BreadcrumbProps {
  items: BreadcrumbItem[]
}

export function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <div className="bg-slate-50 py-4 border-b border-slate-200">
      <div className="container mx-auto px-6">
        <nav aria-label="Breadcrumb">
          <ol className="flex items-center space-x-2 text-sm text-slate-600">
            {items.map((item, index) => (
              <li key={index} className="flex items-center">
                {index > 0 && <span className="mr-2">/</span>}
                {item.current ? (
                  <span className="text-slate-900 font-medium">{item.label}</span>
                ) : (
                  <Link 
                    href={item.href || '#'} 
                    className="hover:text-[#00a1d6] transition-colors"
                  >
                    {item.label}
                  </Link>
                )}
              </li>
            ))}
          </ol>
        </nav>
      </div>
    </div>
  )
}
